/**
 * errorCode enum from LW API response body
 */
export enum LW_API_ERROR_CODE_ENUM {
  USER_REGISTERED = 'USER_REGISTERED',
  USER_EXISTS = 'USER_EXISTS',
  USER_REGISTERED_DIFFERENT_CUSTOMER = 'USER_REGISTERED_DIFFERENT_CUSTOMER',
  USER_ACCOUNT_UNRECOGNIZED = 'USER_ACCOUNT_UNRECOGNIZED',
  USER_ACCOUNT_PENDING_VERIFICATION = 'USER_ACCOUNT_PENDING_VERIFICATION',
  INELIGIBLE_USER = 'INELIGIBLE_USER',
  INVALID_FACTOR_CODE = 'INVALID_FACTOR_CODE',
  INVALID_OKTA_PASSWORD = 'INVALID_OKTA_PASSWORD',
  USER_ACCOUNT_EXPIRED_MESSAGE = 'USER_ACCOUNT_EXPIRED_MESSAGE',
  INVALID_PAYMENT_INFO = 'INVALID_PAYMENT_INFO',
  SSO_LOGIN_EMAIL_CONFLICT = 'SSO_LOGIN_EMAIL_CONFLICT',
  PARTNER_SSO_TOKEN_EXPIRED = 'PARTNER_SSO_TOKEN_EXPIRED',
  CHILD_EMAIL_REGISTERED = 'CHILD_EMAIL_REGISTERED',
  PASSWORD_RESET_REQUIRED_FOR_DEMO = 'PASSWORD_RESET_REQUIRED_FOR_DEMO',
  TEEN_ALREADY_CLAIMED = 'TEEN_ALREADY_CLAIMED',
  TEEN_EMAIL_IN_USE = 'TEEN_EMAIL_IN_USE',
}

/**
 * errorCode from LW API response body
 */
export type LW_API_ERROR_CODE = `${LW_API_ERROR_CODE_ENUM}`

/**
 * errorCode enum from Add New Client API response body
 */
export enum ADD_NEW_CLIENT_ERROR_CODE_ENUM {
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  ALREADY_ON_CASELOAD = 'ALREADY_ON_CASELOAD',
}
